// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from "@firebase/firestore";
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyCToqbHh2oMSpoGoHAqV3XDJp_7GmKoI04",
  authDomain: "disco-15a67.firebaseapp.com",
  projectId: "disco-15a67",
  storageBucket: "disco-15a67.appspot.com",
  messagingSenderId: "778373378298",
  appId: "1:778373378298:web:c2995f172bc33666fc9943",
  measurementId: "G-MS7EK5Y2BT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);
const db = getFirestore(app);

export {db}